export default "__VITE_ASSET__PIULoxuL__"